import { useMemo } from "react";
import { Col, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ReactSelect from "react-select";

import { personsSummaryQuery } from "../api";
import { reactSelectPersonSettings } from "./reactselect";
import { personOption } from "./utils";
import { useQuery } from "@tanstack/react-query";

// filters out the person's with numbers in excludedNumbers[]
export function PersonSelectSupervisor({ disabled, isPersonal, selectedPerson, selectChange, excludedNumbers = [], controlId = "personNumber", label }) {
  const { t } = useTranslation();

  const query = personsSummaryQuery("all");
  const { data } = useQuery({ ...query, enabled: !isPersonal }); // Only runs when not personal

  // Derived data instead of useState
  const options = useMemo(() => {
    if (!data) return [];
    return data.data?.reduce((filtered, person) => {
      if (!excludedNumbers.includes(person.personNumber)) {
        filtered.push(personOption(person, t, true));
      }
      return filtered;
    }, []);
  }, [data, excludedNumbers, t]);


  return <Form.Group as={Col} controlId={controlId}>
    <Form.Label>{ label || (disabled ? t("Person", "Henkilö") : t("PersonSelect", "Henkilövalinta")) }</Form.Label>
    <ReactSelect
      inputId={controlId}
      name={controlId}
      options={options}
      onChange={selectChange}
      value={isPersonal && selectedPerson?.personNumber ? personOption(selectedPerson, t, true) : options?.find(option => option.value === selectedPerson?.personNumber)}
      isDisabled={disabled}
      isClearable
      {...reactSelectPersonSettings(t)}
    />
    <Form.Control.Feedback type="invalid">{t("PersonIsMandatory", "Henkilö on pakollinen")}.</Form.Control.Feedback>
  </Form.Group>;
}
